import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_URL || 'http://localhost:8000/graphql/',
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('authToken');
  
  // Get storeId from URL if available, otherwise fall back to localStorage
  let storeId = localStorage.getItem('storeId');
  
  // Check if we're on a store-specific route and extract storeId from URL
  const currentPath = window.location.pathname;
  const storeRouteMatch = currentPath.match(/^\/store\/([^\/]+)/);
  if (storeRouteMatch) {
    storeId = storeRouteMatch[1];
  }
  
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      'store-id': storeId || '',
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(
        `GraphQL error: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
      
      // Only logout if it's actually an authentication error and message exists
      if (message && (message.includes('Authentication') || message.includes('Unauthorized') || message.includes('Invalid token'))) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('storeId');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    });
  }

  if (networkError) {
    console.error(`Network error: ${networkError}`);
    
    // Handle 401 errors by redirecting to login, but only for auth-related issues
    if ('statusCode' in networkError && networkError.statusCode === 401) {
      // Check if this is a token-related error
      const errorMessage = networkError.message || '';
      if (errorMessage.includes('token') || errorMessage.includes('auth') || errorMessage.includes('Unauthorized')) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('storeId');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
  }
});

export const apolloClient = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          allAppointments: {
            merge: false,
          },
          allStaff: {
            merge: false,
          },
          allServices: {
            merge: false,
          },
          allStores: {
            merge: false,
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'ignore',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});
